import React, { useState, useEffect } from 'react';



import { useSearchParams } from 'react-router-dom';



import { Eye, EyeOff } from 'lucide-react';



import AnnouncementBar from '../components/AnnouncementBar';



import Footer from '../components/Footer';

import RotatingQrImg from '../components/RotatingQrImg';



import TornPaperWrapper from '../components/TornPaperWrapper';



import api from '../services/api';



import toast from '../utils/toast';



import { useAuth } from '../context/AuthContext';



import { getCmsImagePath } from '../cms/cmsData';



import { trackPurchase, trackCompleteRegistration, identifyUser } from '../utils/metaPixel';

import { trackGaPurchase } from '../utils/ga4';

import UpsellBanner from '../components/upsell/UpsellBanner';

import './SuccessReplica.css';







// QR placeholder removed — real QR codes are now generated server-side with qrserver.com fallback







const OrderSuccess = () => {



  const [searchParams] = useSearchParams();



  const { isAuthenticated, updateUser } = useAuth();



  const [activeTicket, setActiveTicket] = useState(0);



  const [loading, setLoading] = useState(true);



  const [orderData, setOrderData] = useState(null);



  const [tickets, setTickets] = useState([]);



  const [error, setError] = useState(null);



  const [showPasswordModal, setShowPasswordModal] = useState(false);



  const [password, setPassword] = useState('');



  const [confirmPassword, setConfirmPassword] = useState('');



  const [showPassword, setShowPassword] = useState(false);



  const [showConfirmPassword, setShowConfirmPassword] = useState(false);



  const [passwordError, setPasswordError] = useState('');



  const [settingPassword, setSettingPassword] = useState(false);

  const [smsConsent, setSmsConsent] = useState(false);



  



  // Auto-popup password modal for non-authenticated users



  const [autoPopupDone, setAutoPopupDone] = useState(false);



  const [emailAlreadyRegistered, setEmailAlreadyRegistered] = useState(false);



  // Google Wallet visibility (from public config) — default OFF until config confirms

  const [googleWalletEnabled, setGoogleWalletEnabled] = useState(false);



  



  useEffect(() => {



    // Users now authenticate BEFORE checkout (via Cart page modal).

    // No auto-popup needed — they should already be logged in.

    setAutoPopupDone(true);



  }, [isAuthenticated, orderData, autoPopupDone, showPasswordModal, searchParams]);







  // DocuSign contract modal state



  const [showContractModal] = useState(false);



  const [contractLoading, setContractLoading] = useState(false);



  const [contractUrl] = useState(null);



  const setContractError = () => {};



  



  // Wallet pass state



  const [_walletLoading, setWalletLoading] = useState({ apple: false, google: false }); // eslint-disable-line no-unused-vars



  const [autoWalletTriggered, setAutoWalletTriggered] = useState(false);



  



  // Detect device type for auto-wallet



  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);



  const isAndroid = /Android/.test(navigator.userAgent);



  



  // Auto-trigger wallet add after order loads (for non-vendor tickets)



  // Only triggers on mobile devices when user is properly authenticated with valid API token



  useEffect(() => {



    // Must have: auth context says authenticated AND api service has a valid token



    const hasValidToken = isAuthenticated && api.isAuthenticated();



    



    if (!autoWalletTriggered && hasValidToken && tickets.length > 0 && !loading) {



      // Find first regular ticket (not vendor booth)



      const regularTicket = tickets.find(t => 



        !t.metadata?.business_type || 



        (t.metadata?.business_type !== 'food' && t.metadata?.business_type !== 'bazaar')



      );



      



      if (regularTicket && (isIOS || isAndroid)) {



        setAutoWalletTriggered(true);



        



        // Small delay to let the page render first



        setTimeout(async () => {



          try {



            if (isIOS) {



              // iOS: Auto-trigger Apple Wallet



              console.log('Auto-triggering Apple Wallet for iOS device');



              const response = await api.createAppleWalletPass(regularTicket.id);



              if (response?.success && response?.download_url) {



                window.location.href = response.download_url;



              }



            } else if (isAndroid && googleWalletEnabled) {



              // Android: Auto-trigger Google Wallet



              console.log('Auto-triggering Google Wallet for Android device');



              const response = await api.createGoogleWalletPass(regularTicket.id);



              if (response?.success && response?.save_url) {



                window.location.href = response.save_url;



              }



            }



          } catch (err) {



            console.error('Auto wallet trigger failed:', err);



            // Silent fail - user can still click buttons manually



          }



        }, 2000);



      }



    }



  }, [autoWalletTriggered, isAuthenticated, tickets, loading, isIOS, isAndroid, googleWalletEnabled]);







  // Upload pending vendor documents from IndexedDB



  const uploadPendingVendorDocuments = async (email) => {



    if (!email) return;



    



    const emailLower = email.toLowerCase();



    console.log('[VendorDocs] Checking for pending uploads for:', emailLower);



    



    try {



      const dbRequest = indexedDB.open('VendorDocuments', 1);



      dbRequest.onupgradeneeded = (event) => {

        const db = event.target.result;

        if (!db.objectStoreNames.contains('pendingUploads')) {

          db.createObjectStore('pendingUploads', { keyPath: 'email' });

        }

      };



      dbRequest.onerror = (event) => {



        console.error('[VendorDocs] IndexedDB open error:', event.target.error);



      };



      



      dbRequest.onsuccess = async (event) => {



        const db = event.target.result;



        console.log('[VendorDocs] IndexedDB opened, stores:', Array.from(db.objectStoreNames));



        



        if (!db.objectStoreNames.contains('pendingUploads')) {



          console.log('[VendorDocs] No pendingUploads store found');



          return;



        }



        



        const transaction = db.transaction(['pendingUploads'], 'readonly');



        const store = transaction.objectStore('pendingUploads');



        



        // Get ALL entries and find matching email (case-insensitive)



        const getAllRequest = store.getAll();



        



        getAllRequest.onerror = (e) => {



          console.error('[VendorDocs] IndexedDB getAll error:', e.target.error);



        };



        



        getAllRequest.onsuccess = async () => {



          const allEntries = getAllRequest.result || [];



          console.log(`[VendorDocs] Found ${allEntries.length} entries in IndexedDB`);



          



          // Find entry matching this email (case-insensitive), fallback to most recent

          let data = allEntries.find(entry => 

            entry.email && entry.email.toLowerCase() === emailLower

          );

          if (!data) {

            data = allEntries.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))[0];

            if (data) console.log(`[VendorDocs] No exact email match, using most recent entry: ${data.email}`);

          }



          if (data && data.files && Object.keys(data.files).length > 0) {



            const fileKeys = Object.keys(data.files);



            console.log('[VendorDocs] Found pending documents to upload:', fileKeys);



            toast.info(`Uploading ${fileKeys.length} pending document(s)...`);



            



            const documentTypeMap = {



              sellerPermit: 'SELLER_PERMIT',



              businessLicense: 'BUSINESS_LICENSE',



              healthPermit: 'HEALTH_PERMIT',



              foodHandler: 'FOOD_HANDLER'



            };



            



            let successCount = 0;



            let failCount = 0;



            



            // Upload all documents



            for (const [key, fileData] of Object.entries(data.files)) {



              if (fileData && documentTypeMap[key]) {



                try {



                  console.log(`[VendorDocs] Preparing ${key}:`, fileData.name, fileData.type, fileData.data?.byteLength || 0, 'bytes');



                  // Reconstruct File object from stored ArrayBuffer + metadata



                  const file = new File(



                    [fileData.data],



                    fileData.name,



                    { type: fileData.type, lastModified: fileData.lastModified }



                  );



                  console.log(`[VendorDocs] Uploading ${key}: ${file.name}, size: ${file.size}`);



                  const response = await api.uploadVendorDocument(documentTypeMap[key], file);



                  console.log(`[VendorDocs] Upload response for ${key}:`, response);



                  if (response?.success) {



                    console.log(`[VendorDocs] Successfully uploaded ${key}`);



                    successCount++;



                  } else {



                    console.error(`[VendorDocs] Upload failed for ${key}:`, response?.error);



                    failCount++;



                  }



                } catch (uploadErr) {



                  console.error(`[VendorDocs] Failed to upload ${key}:`, uploadErr);



                  failCount++;



                }



              }



            }



            



            // Show result toast



            if (successCount > 0 && failCount === 0) {



              toast.success(`Successfully uploaded ${successCount} document(s)!`);



            } else if (successCount > 0 && failCount > 0) {



              toast.warning(`Uploaded ${successCount} document(s), ${failCount} failed`);



            } else if (failCount > 0) {



              toast.error(`Failed to upload ${failCount} document(s). Please upload manually in your dashboard.`);



            }



            



            // Clear the stored files after upload attempt in a new transaction



            const deleteRequest = indexedDB.open('VendorDocuments', 1);



            deleteRequest.onsuccess = (e) => {



              const deleteDb = e.target.result;



              const deleteTx = deleteDb.transaction(['pendingUploads'], 'readwrite');



              const deleteStore = deleteTx.objectStore('pendingUploads');



              deleteStore.delete(data.email); // Use original email key



              console.log('[VendorDocs] Cleared IndexedDB pending uploads');



            };



          } else {



            console.log('[VendorDocs] No pending documents found for email:', emailLower);



          }



        };



      };



    } catch (err) {



      console.error('[VendorDocs] Error accessing IndexedDB for document upload:', err);



    }



  };







  useEffect(() => {



    const fetchOrderData = async (retryCount = 0) => {



      const sessionId = searchParams.get('session_id');



      



      if (!sessionId) {



        setError('No session ID found');



        setLoading(false);



        return;



      }







      try {



        // Fetch public config for feature flags (Google Wallet) — await so

        // the toggle value is known before we render wallet buttons / auto-trigger

        try {

          const configRes = await api.getPublicConfig();

          if (configRes?.success && configRes.data) {

            setGoogleWalletEnabled(configRes.data.google_wallet_enabled ?? false);

          }

        } catch (_) { /* keep default (false) */ }



        // Clear cart after successful payment (coupon is session-only, no localStorage to clear)



        localStorage.removeItem('cart');

        localStorage.removeItem('pendingCheckoutCart');

        localStorage.removeItem('pendingCart');



        window.dispatchEvent(new CustomEvent('cartUpdated', { 



          detail: { items: [], total: 0 } 



        }));







        // Fetch order details from backend



        const response = await api.getOrderBySessionId(sessionId);



        



        if (response.success && response.data) {



          const order = response.data.order;



          const ticketList = response.data.tickets || [];



          // If backend returned the real Stripe email (buyer is temp user), use it

          const stripeEmail = response.data.stripe_email;

          if (stripeEmail && order.buyer) {

            order.buyer.email = stripeEmail;

            order.buyer._real_email = stripeEmail;

          }



          console.log('Order data:', order);



          console.log('Tickets:', ticketList);



          



          // If no tickets yet and we haven't retried too many times, wait and retry



          // This handles the case where finalization is still in progress



          if (ticketList.length === 0 && retryCount < 5) {



            console.log(`No tickets found, retrying in 2 seconds (attempt ${retryCount + 1}/5)...`);



            setTimeout(() => fetchOrderData(retryCount + 1), 2000);



            return;



          }



          



          setOrderData(order);



          



          // Sort tickets: vendor booth first, then regular (by type: 1-day, 2-day, 3-day),

          // multi-day passes grouped by pass (all days of pass #1 before pass #2), then comp last.

          const getPriority = (ticket) => {

            if (ticket.metadata?.business_type === 'food' || ticket.metadata?.business_type === 'bazaar') return 0;

            if (ticket.is_comp || ticket.metadata?.complimentary ||

                ticket.ticket_type_name?.toLowerCase().includes('complimentary')) return 2;

            return 1;

          };



          // Separate into priority groups

          const vendorTix = ticketList.filter(t => getPriority(t) === 0);

          const regularTix = ticketList.filter(t => getPriority(t) === 1);

          const compTix = ticketList.filter(t => getPriority(t) === 2);



          // Sort regular tickets: group by ticket_type_name, order types by total_days ascending,

          // then within each type group multi-day passes together by pass number

          const typeGroups = {};

          regularTix.forEach(t => {

            const key = t.ticket_type_name || 'Unknown';

            if (!typeGroups[key]) typeGroups[key] = [];

            typeGroups[key].push(t);

          });



          const sortedTypeNames = Object.keys(typeGroups).sort((a, b) => {

            const daysA = typeGroups[a][0]?.metadata?.total_days || 1;

            const daysB = typeGroups[b][0]?.metadata?.total_days || 1;

            return daysA - daysB;

          });



          const sortedRegular = [];

          for (const typeName of sortedTypeNames) {

            const group = typeGroups[typeName];

            const totalDays = group[0]?.metadata?.total_days || 1;



            if (totalDays > 1 && group.length > totalDays) {

              // Multi-day, multiple passes: group by day_number first, then interleave by pass

              group.sort((a, b) => {

                const dayDiff = (a.metadata?.day_number || 0) - (b.metadata?.day_number || 0);

                if (dayDiff !== 0) return dayDiff;

                return (a.ticket_code || '').localeCompare(b.ticket_code || '');

              });

              const dayBuckets = {};

              group.forEach(t => {

                const day = t.metadata?.day_number || 1;

                if (!dayBuckets[day]) dayBuckets[day] = [];

                dayBuckets[day].push(t);

              });

              const days = Object.keys(dayBuckets).sort((a, b) => Number(a) - Number(b));

              const passCount = dayBuckets[days[0]]?.length || 1;

              for (let p = 0; p < passCount; p++) {

                for (const day of days) {

                  if (dayBuckets[day][p]) sortedRegular.push(dayBuckets[day][p]);

                }

              }

            } else {

              // Single day or single pass

              group.sort((a, b) => (a.metadata?.day_number || 0) - (b.metadata?.day_number || 0));

              sortedRegular.push(...group);

            }

          }



          const sortedTickets = [...vendorTix, ...sortedRegular, ...compTix];



          



          setTickets(sortedTickets);



          setLoading(false);



          // ── Meta Pixel: Purchase event with value + currency ──

          const totalDollars = (order.total_cents || 0) / 100;

          const buyerEmail = order.buyer?._real_email || order.buyer?.email;

          const buyerName = order.buyer?.full_name || '';

          const nameParts = buyerName.split(' ');

          identifyUser({

            email: buyerEmail,

            phone: order.buyer?.phone,

            firstName: nameParts[0],

            lastName: nameParts.slice(1).join(' '),

          });

          trackPurchase({

            value: totalDollars,

            currency: 'USD',

            contentIds: sortedTickets.map(t => t.id),

            contentName: sortedTickets.map(t => t.ticket_type_name).join(', '),

            numItems: sortedTickets.length,

            orderNumber: order.order_number,

            userData: {

              email: buyerEmail,

              phone: order.buyer?.phone,

              firstName: nameParts[0],

              lastName: nameParts.slice(1).join(' '),

            },

          });



          if (totalDollars > 0) {

            const hasAmphitheater = (order.items || []).some(i => (i.ticket_type_name || '').toLowerCase().includes('amphitheater') || (i.ticket_type_name || '').toLowerCase().includes('pacific'));

            const hasVendor = (order.items || []).some(i => (i.ticket_type_name || '').toLowerCase().includes('vendor') || (i.ticket_type_name || '').toLowerCase().includes('booth'));

            trackGaPurchase({

              orderNumber: order.order_number,

              value: totalDollars,

              currency: 'USD',

              tax: (order.tax_cents || 0) / 100,

              items: (order.items || []).map(item => ({

                id: item.id,

                ticket_type: item.ticket_type,

                ticket_type_name: item.ticket_type_name || item.name,

                unit_price: item.unit_price ?? ((item.unit_price_cents || 0) / 100),

                quantity: item.quantity || 1,

              })),

              search: searchParams.toString() ? `?${searchParams.toString()}` : '',

              purchaseType: hasVendor ? 'vendor_booth' : hasAmphitheater ? 'concert_ticket' : 'festival_ticket',

              ticketType: hasVendor ? 'vendor' : hasAmphitheater ? 'concert' : 'festival',

            });

          }



          // Upload pending vendor documents if user is already authenticated

          // (Documents are also uploaded after account creation in handleSetPassword)

          if (isAuthenticated && sortedTickets.some(t => t.metadata?.business_type === 'food' || t.metadata?.business_type === 'bazaar')) {

            const vendorEmail = order?.buyer?.email || order?.buyer?._real_email;

            if (vendorEmail) {

              uploadPendingVendorDocuments(vendorEmail);

            }

          }



          



          // Handle DocuSign completion redirect



          if (searchParams.get('docusign') === 'complete') {



            toast.success('Contract signed successfully! Redirecting to your dashboard...');



            setTimeout(() => {



              window.location.href = '/dashboard';



            }, 2000);



          }



        } else {



          // If order not found yet, retry a few times



          if (retryCount < 3) {



            console.log(`Order not found, retrying in 2 seconds (attempt ${retryCount + 1}/3)...`);



            setTimeout(() => fetchOrderData(retryCount + 1), 2000);



            return;



          }



          setError('Failed to load order details');



          setLoading(false);



        }



      } catch (err) {



        console.error('Error fetching order:', err);



        if (retryCount < 3) {



          console.log(`Error occurred, retrying in 2 seconds (attempt ${retryCount + 1}/3)...`);



          setTimeout(() => fetchOrderData(retryCount + 1), 2000);



          return;



        }



        setError('An error occurred while loading your order');



        setLoading(false);



      }



    };







    fetchOrderData();



  }, [searchParams, isAuthenticated]);







  const handleSetPassword = async (e) => {



    e.preventDefault();



    setPasswordError('');



    



    if (password.length < 8) {



      setPasswordError('Password must be at least 8 characters');



      return;



    }



    



    if (password !== confirmPassword) {



      setPasswordError('Passwords do not match');



      return;



    }



    



    setSettingPassword(true);



    try {



      // Use best available email: _real_email (from Stripe) > buyer.email

      const bestEmail = orderData.buyer?._real_email || orderData.buyer?.email;

      const response = await api.createAccountFromGuest({



        email: bestEmail,



        password: password,



        order_id: orderData.id,



        sms_consent: smsConsent



      });



      



      if (response?.success) {



        // ── Meta Pixel: CompleteRegistration ──

        const regName = orderData.buyer?.full_name || '';

        const regParts = regName.split(' ');

        trackCompleteRegistration({

          status: 'complete',

          userData: { email: bestEmail, firstName: regParts[0], lastName: regParts.slice(1).join(' ') },

        });



        // Store tokens for login - MUST use api.setTokens to update both sessionStorage AND api instance



        if (response.data?.tokens) {



          api.setTokens(response.data.tokens.access, response.data.tokens.refresh);



          if (response.data.user) {



            api.setUser(response.data.user);



            // Update React AuthContext state so isAuthenticated becomes true immediately

            // This enables wallet buttons without requiring a page reload or manual login

            updateUser(response.data.user);



          }



        }



        // Account created successfully - user will be logged in



        



        // NOW upload any pending vendor documents (user is authenticated)



        // Try both buyer email and the email used in checkout form (they might differ)



        const buyerEmail = orderData.buyer?.email;



        if (buyerEmail) {



          await uploadPendingVendorDocuments(buyerEmail);



        }



        // Also try with the email from the order itself



        const orderEmail = orderData?.email;



        if (orderEmail && orderEmail !== buyerEmail) {



          await uploadPendingVendorDocuments(orderEmail);



        }



        



        setShowPasswordModal(false);



        



        // Check if this is a vendor booth order - auto-trigger contract signing



        const isVendorOrder = tickets.some(t => 



          t.metadata?.business_type === 'food' || t.metadata?.business_type === 'bazaar'



        );



        



        if (isVendorOrder) {



          toast.success('Account created! Redirecting to sign your vendor contract...');



          // Auto-trigger DocuSign contract signing - redirect like Dashboard does



          try {



            setContractLoading(true);



            const returnUrl = `${window.location.origin}/dashboard?docusign=complete`;



            const contractRes = await api.createDocuSignContract(returnUrl);



            if (contractRes?.success && contractRes?.signing_url) {



              // Validate signing URL before redirect



              if (!contractRes.signing_url.startsWith('https://')) {



                console.error('Invalid signing URL:', contractRes.signing_url);



                toast.error('Invalid contract URL. Redirecting to dashboard...');



                window.location.href = '/dashboard';



                return;



              }



              // Redirect to DocuSign embedded signing (same approach as Dashboard)



              window.location.href = contractRes.signing_url;



            } else {



              toast.error('Could not load contract. You can sign it from your Vendor Dashboard.');



              window.location.href = '/dashboard';



            }



          } catch (contractErr) {



            console.error('DocuSign auto-trigger error:', contractErr);



            toast.error('Contract service unavailable. Sign it from your Vendor Dashboard.');



            window.location.href = '/dashboard';



          } finally {



            setContractLoading(false);



          }



        } else {



          toast.success('Account created successfully! You can navigate to your dashboard anytime.');



          // Stay on the success page - don't redirect



        }



      } else {



        setPasswordError(response?.error?.message || response?.error || 'Failed to create account');



      }



    } catch (err) {



      // Handle already_registered response - show login instead

      if (err.response?.data?.already_registered) {

        setEmailAlreadyRegistered(true);

        setPasswordError('');

        toast.info(`Account exists for ${err.response.data.email}. Your tickets have been linked. Please login.`);

        setSettingPassword(false);

        return;

      }



      // Handle error from API response



      const errorMsg = err.response?.data?.error || err.message || 'Failed to create account';



      setPasswordError(errorMsg);



    } finally {



      setSettingPassword(false);



    }



  };







  // DocuSign contract signing handler - opens in new window for better UX



  const handleSignContract = async () => {



    setContractLoading(true);



    setContractError('');



    try {



      // Return URL goes to vendor dashboard after signing



      const returnUrl = `${window.location.origin}/dashboard?docusign=complete`;



      console.log('DocuSign: Creating contract with return URL:', returnUrl);



      



      const response = await api.createDocuSignContract(returnUrl);



      console.log('DocuSign: API response:', JSON.stringify(response, null, 2));



      



      if (response?.success && response?.signing_url) {



        console.log('DocuSign: Opening signing URL:', response.signing_url);



        



        // Validate the signing URL



        if (!response.signing_url.startsWith('https://')) {



          console.error('DocuSign: Invalid signing URL:', response.signing_url);



          setContractError('Invalid contract URL received. Please contact support.');



          toast.error('Invalid contract URL. Please contact support.');



          return;



        }



        



        // Open DocuSign in new window/tab - better UX than iframe



        toast.info('Opening contract for signing. Complete signing to continue.');



        window.open(response.signing_url, '_blank');



      } else {



        const errorMsg = response?.error?.message || response?.error || 'Failed to create contract';



        console.error('DocuSign failed:', { response, errorMsg });



        setContractError(errorMsg);



        toast.error('Could not create contract. You can sign it later from your Vendor Dashboard.');



      }



    } catch (err) {



      console.error('DocuSign error:', err);



      const errorDetail = err.response?.data?.error?.message || err.message || 'Unknown error';



      setContractError(`Contract service error: ${errorDetail}`);



      toast.error('Contract service unavailable. You can sign it later from your dashboard.');



    } finally {



      setContractLoading(false);



    }



  };







  const handleDownloadPDF = () => {



    if (!orderData?.id) {



      console.error('No order ID available for PDF download');



      toast.error('Order information not available. Please refresh the page.');



      return;



    }



    // Use direct URL download - works with or without auth



    const pdfUrl = api.getOrderPdfUrl(orderData.id);



    const a = document.createElement('a');



    a.href = pdfUrl;



    a.download = `OC-MENA-Festival-Tickets-${orderData.order_number}.pdf`;



    document.body.appendChild(a);



    a.click();



    document.body.removeChild(a);



  };







  // Apple Wallet pass handler



  const handleAppleWallet = async (ticketId) => {



    setWalletLoading(prev => ({ ...prev, apple: true }));



    // Open blank window BEFORE async call to avoid popup blocker (non-iOS only)

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    const walletWindow = !isIOS ? window.open('about:blank', '_blank') : null;



    try {



      const response = await api.createAppleWalletPass(ticketId);



      if (response?.inAppBrowser) {

        if (walletWindow && !walletWindow.closed) walletWindow.close();

        toast.error(response.error.message);

        return;

      }



      if (response?.success && response?.download_url) {

        if (isIOS) {

          window.location.href = response.download_url;

        } else if (walletWindow && !walletWindow.closed) {

          walletWindow.location.href = response.download_url;

        } else {

          window.location.href = response.download_url;

        }

        return;

      }



      if (walletWindow && !walletWindow.closed) walletWindow.close();

      toast.error(response?.error?.message || 'Apple Wallet is not available yet.');



    } catch (err) {



      if (walletWindow && !walletWindow.closed) walletWindow.close();

      console.error('Apple Wallet error:', err);

      toast.error('Apple Wallet is not available. Please download your ticket PDF instead.');



    } finally {



      setWalletLoading(prev => ({ ...prev, apple: false }));



    }



  };







  // Google Wallet pass handler



  const handleGoogleWallet = async (ticketId) => {



    setWalletLoading(prev => ({ ...prev, google: true }));



    // Open blank window BEFORE async call to avoid popup blocker

    const walletWindow = window.open('about:blank', '_blank');



    try {



      const response = await api.createGoogleWalletPass(ticketId);



      if (response?.success && response?.save_url) {



        if (walletWindow && !walletWindow.closed) {

          walletWindow.location.href = response.save_url;

        } else {

          // Fallback: direct navigation if popup was still blocked

          window.location.href = response.save_url;

        }



        toast.success('Opening Google Wallet...');



      } else {



        if (walletWindow && !walletWindow.closed) walletWindow.close();



        const errorMsg = response?.error?.message || 'Google Wallet is not available yet. Please download your ticket PDF instead.';



        toast.error(errorMsg);



      }



    } catch (err) {



      if (walletWindow && !walletWindow.closed) walletWindow.close();



      console.error('Google Wallet error:', err);



      toast.error('Google Wallet is not available. Please download your ticket PDF instead.');



    } finally {



      setWalletLoading(prev => ({ ...prev, google: false }));



    }



  };







  if (loading) {



    return (



      <div style={{

        position: 'fixed',

        inset: 0,

        zIndex: 99999,

        background: '#ffffff',

        display: 'flex',

        flexDirection: 'column',

        alignItems: 'center',

        justifyContent: 'center',

        gap: '28px'

      }}>

        <img loading="lazy" src={getCmsImagePath('logo', '/logo.webp')} alt="OC MENA Festival" style={{ height: 80, objectFit: 'contain', opacity: 0.95 }} />

        <div style={{

          width: 40,

          height: 40,

          border: '3px solid rgba(0,0,0,0.15)',

          borderTopColor: '#dc2626',

          borderRadius: '50%',

          animation: 'splash-spin 0.8s linear infinite'

        }} />

        <p style={{ color: '#333333', fontSize: 16, fontWeight: 500, margin: 0, letterSpacing: '0.5px' }}>

          Loading your order...

        </p>

        <style>{`@keyframes splash-spin { to { transform: rotate(360deg); } }`}</style>

      </div>



    );



  }







  if (error || !orderData) {



    return (



      <div className="page-wrapper">



        <AnnouncementBar />



        <section className="hero-section">



          <div className="hero-background-wrapper">



            <video src={"/hero-final.mp4"} alt="OC MENA Festival" className="hero-background-video" autoPlay muted loop playsInline />



            <div className="hero-gradient-overlay"></div>



          </div>



          <TornPaperWrapper>



            <div style={{ textAlign: 'center', padding: '40px' }}>



              <h2>Order Not Found</h2>



              <p>{error || 'Unable to load order details'}</p>



            </div>



          </TornPaperWrapper>



        </section>



        <Footer />



      </div>



    );



  }







  return (



    <div className="page-wrapper">



      <AnnouncementBar />



      



      {/* Hero Section with Background */}



      <section className="hero-section">



        <div className="hero-background-wrapper">



          <video src={"/hero-final.mp4"} alt="OC MENA Festival" className="hero-background-video" autoPlay muted loop playsInline />



          <div className="hero-gradient-overlay"></div>



        </div>







        {/* Torn Paper Card */}



        <TornPaperWrapper>



          <h1 className="card-title">Thank you!</h1>



          <p className="card-subtitle">Your order is confirmed. {tickets.length > 0 ? `You have ${tickets.length} ticket${tickets.length !== 1 ? 's' : ''} in total.` : `Order #${orderData.order_number}`}</p>







          <div className="sr-ticket-area">



            <div className="sr-ticket-header">



              <span className="sr-ticket-count">Ticket {activeTicket + 1}/{tickets.length || 1}</span>



              <span className="sr-details-label">Details</span>



            </div>







            <div className="sr-top-grid">



              <div className="sr-qr-panel">



                {(() => {

                  const currentTicket = tickets[activeTicket];

                  if (!currentTicket) return null;

                  const typeName = currentTicket.ticket_type_name || 'Ticket';

                  const is3DayPass = typeName.toLowerCase().includes('3-day') || typeName.toLowerCase().includes('3 day');

                  const isAmphitheater = currentTicket.metadata?.amphitheater;

                  const isVendor = typeName.toLowerCase().includes('vendor') || typeName.toLowerCase().includes('booth');

                  // Build counter for tickets of the same type

                  const sameTypeTickets = tickets.filter(t => t.ticket_type_name === currentTicket.ticket_type_name);

                  const zeroIdx = sameTypeTickets.indexOf(currentTicket);

                  const totalOfType = sameTypeTickets.length;

                  const totalDays = currentTicket.metadata?.total_days || 1;

                  const passNumber = Math.floor(zeroIdx / totalDays) + 1;

                  const ticketInPass = (zeroIdx % totalDays) + 1;

                  const totalPasses = Math.ceil(totalOfType / totalDays);



                  let displayLabel;

                  if (totalOfType <= 1) {

                    displayLabel = typeName;

                  } else if (totalDays === 1) {

                    displayLabel = `${typeName} #${passNumber}`;

                  } else if (totalPasses === 1) {

                    displayLabel = `${typeName} (Ticket ${ticketInPass})`;

                  } else {

                    displayLabel = `${typeName} #${passNumber} (Ticket ${ticketInPass})`;

                  }

                  return (

                    <div style={{textAlign: 'center', marginBottom: '0.25rem'}}>

                      <h3 style={{margin: '0 0 0.25rem 0', color: isVendor ? '#6b21a8' : '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', fontSize: '1.05rem'}}>

                        {isVendor && '🏪 '}

                        {isAmphitheater && '🎵 '}

                        {displayLabel}

                      </h3>

                      {is3DayPass && !isVendor && !currentTicket.metadata?.total_days && (

                        <p style={{margin: '0 0 0.5rem 0', color: '#666', fontSize: '0.9rem', fontStyle: 'italic'}}>

                          {currentTicket.metadata?.valid_for_date 

                            ? `Valid for ${new Date(currentTicket.metadata.valid_for_date + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}`

                            : 'Valid for 1 day (of your choice)'}

                        </p>

                      )}

                      {isVendor && currentTicket.metadata?.type === 'vendor-booth' && (

                        <p style={{margin: '0 0 0.5rem 0', color: '#7c3aed', fontSize: '0.9rem', fontStyle: 'italic'}}>

                          Booth pass — valid for all 3 festival days

                        </p>

                      )}

                      {isAmphitheater && currentTicket.metadata?.section && (

                        <p style={{margin: '0 0 0.5rem 0', color: '#666', fontSize: '0.9rem'}}>

                          {currentTicket.metadata.section}

                          {currentTicket.metadata.row ? ` · Row ${currentTicket.metadata.row}` : ''}

                          {currentTicket.metadata.seat_number ? ` · Seat ${currentTicket.metadata.seat_number}` : ''}

                        </p>

                      )}

                    </div>

                  );

                })()}



                {/* Hide QR for vendor booth tickets - they're booth passes, not scannable entry */}

                {tickets[activeTicket]?.metadata?.type === 'vendor-booth' ? (

                  <div style={{

                    width: '200px', height: '200px', display: 'flex', flexDirection: 'column',

                    alignItems: 'center', justifyContent: 'center', border: '2px solid #7c3aed',

                    borderRadius: '12px', backgroundColor: '#f5f3ff', margin: '0 auto'

                  }}>

                    <span style={{fontSize: '2.5rem'}}>🏪</span>

                    <p style={{margin: '0.5rem 0 0', fontWeight: '600', color: '#6b21a8', fontSize: '0.9rem', textAlign: 'center'}}>Vendor Booth Pass</p>

                    <p style={{margin: '0.25rem 0 0', color: '#7c3aed', fontSize: '0.75rem', textAlign: 'center'}}>Sign your contract to<br/>activate your booth</p>

                  </div>

                ) : (

                  <RotatingQrImg ticket={tickets[activeTicket]} size={400} alt="Ticket QR" className="sr-qr" />

                )}



                {tickets.length > 1 && (



                  <div className="sr-ticket-nav">



                    <button 



                      className="sr-nav-btn" 



                      onClick={() => setActiveTicket(prev => Math.max(0, prev - 1))}



                      disabled={activeTicket === 0}



                    >



                      ← Prev



                    </button>



                    <div className="sr-dots">



                      {tickets.map((_, idx) => (



                        <span 



                          key={idx} 



                          className={`dot ${idx === activeTicket ? 'active' : ''}`}



                          onClick={() => setActiveTicket(idx)}



                        />



                      ))}



                    </div>



                    <button 



                      className="sr-nav-btn" 



                      onClick={() => setActiveTicket(prev => Math.min(tickets.length - 1, prev + 1))}



                      disabled={activeTicket === tickets.length - 1}



                    >



                      Next →



                    </button>



                  </div>



                )}





              </div>







              <div className="sr-details-panel">



                <div className="sr-detail-group">



                  <label>TICKET TYPE</label>



                  <div className="sr-pill-row">



                    <span className="pill pill-green">



                      {(tickets[activeTicket]?.amphitheater_ticket || tickets[activeTicket]?.metadata?.amphitheater)

                        ? `${tickets[activeTicket]?.ticket_type_name || 'Amphitheater Ticket'} - Seating`

                        : (tickets[activeTicket]?.ticket_type_name || 'Ticket')}



                    </span>



                  </div>



                  {tickets[activeTicket]?.ticket_code && (



                    <p className="sr-ticket-code">Code: {tickets[activeTicket].ticket_code}</p>



                  )}



                  



                  {/* Amphitheater Ticket Details */}



                  {tickets[activeTicket]?.amphitheater_ticket && (



                    <>



                      <p className="sr-section-info" style={{ marginTop: '8px', fontWeight: 'bold', color: '#dc2626' }}>



                        Amphitheater Reserved Seating



                      </p>



                      <p className="sr-section-info">



                        Section: {tickets[activeTicket].amphitheater_ticket.section_name}



                      </p>



                      <p className="sr-section-info">



                        Row {tickets[activeTicket].amphitheater_ticket.row}, Seat {tickets[activeTicket].amphitheater_ticket.seat_number}



                      </p>



                      {tickets[activeTicket].amphitheater_ticket.event_date && (



                        <p className="sr-section-info">



                          Event: {new Date(tickets[activeTicket].amphitheater_ticket.event_date + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}



                        </p>



                      )}



                    </>



                  )}



                  



                  {/* Per-day ticket date display - only for single-day passes */}



                  {tickets[activeTicket]?.metadata?.valid_for_date && !tickets[activeTicket]?.metadata?.total_days && (



                    <p className="sr-section-info" style={{ marginTop: '6px', fontWeight: '600', color: '#7c3aed' }}>

                      {(() => {

                        try {

                          const d = new Date(tickets[activeTicket].metadata.valid_for_date + 'T00:00:00');

                          return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });

                        } catch { return tickets[activeTicket].metadata.valid_for_date; }

                      })()}

                    </p>



                  )}



                  {/* Regular Ticket with Metadata */}



                  {!tickets[activeTicket]?.amphitheater_ticket && tickets[activeTicket]?.metadata?.section_name && (



                    <p className="sr-section-info">Section: {tickets[activeTicket].metadata.section_name}</p>



                  )}



                  {!tickets[activeTicket]?.amphitheater_ticket && tickets[activeTicket]?.metadata?.seats && (



                    <p className="sr-section-info">{tickets[activeTicket].metadata.seats}</p>



                  )}



                  



                  {/* Vendor Booth Details */}



                  {tickets[activeTicket]?.metadata?.business_type && (



                    <>



                      <p className="sr-section-info" style={{ marginTop: '8px', fontWeight: 'bold', color: '#7c3aed' }}>



                        🏪 Vendor Booth Access



                      </p>



                      {tickets[activeTicket].metadata.booth_name && (



                        <p className="sr-section-info">Booth: {tickets[activeTicket].metadata.booth_name}</p>



                      )}



                      {tickets[activeTicket].metadata.legal_business_name && (



                        <p className="sr-section-info">Business: {tickets[activeTicket].metadata.legal_business_name}</p>



                      )}



                      {tickets[activeTicket].metadata.business_type && (



                        <p className="sr-section-info">Type: {tickets[activeTicket].metadata.business_type === 'food' ? 'Food Vendor' : 'Bazaar Vendor'}</p>



                      )}



                      {tickets[activeTicket].metadata.contact_email && (



                        <p className="sr-section-info">Contact: {tickets[activeTicket].metadata.contact_email}</p>



                      )}



                    </>



                  )}



                </div>







                {tickets[activeTicket]?.amphitheater_ticket || tickets[activeTicket]?.metadata?.amphitheater ? (

                  <>

                    <div className="sr-detail-group">

                      <label>CONCERT DATE &amp; TIME</label>

                      <div className="sr-date-row">

                        <span>

                          {tickets[activeTicket]?.amphitheater_ticket?.event_date

                            ? (() => {

                                const d = new Date(tickets[activeTicket].amphitheater_ticket.event_date + 'T00:00:00');

                                return `${d.toLocaleDateString('en-US', { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' })}: 5 PM`;

                              })()

                            : (tickets[activeTicket]?.metadata?.event_date

                                ? (() => {

                                    const d = new Date(tickets[activeTicket].metadata.event_date + 'T00:00:00');

                                    return `${d.toLocaleDateString('en-US', { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' })}: 5 PM`;

                                  })()

                                : 'Sat, June 20, 2026: 5 PM')}

                        </span>

                      </div>

                    </div>

                    <div className="sr-detail-group">

                      <label>FESTIVAL HOURS</label>

                      <div className="sr-date-row">

                        <span>Festival Gates Open: 11 AM</span>

                      </div>

                    </div>

                  </>

                ) : (

                  <div className="sr-detail-group">

                    <label>DATE &amp; TIME</label>

                    <div className="sr-date-row">

                      <span>

                        {tickets[activeTicket]?.metadata?.valid_for_date && !tickets[activeTicket]?.metadata?.total_days

                          ? new Date(tickets[activeTicket].metadata.valid_for_date + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' })

                          : (tickets[activeTicket]?.metadata?.event_date

                              ? new Date(tickets[activeTicket].metadata.event_date + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric' })

                              : 'Friday, June 19 \u2013 Sunday, June 21, 2026')}

                      </span>

                    </div>

                    <div className="sr-date-row" style={{ marginTop: '4px' }}>

                      <span style={{ fontSize: '0.9em', color: '#555' }}>Festival gates open: 11 AM</span>

                    </div>

                  </div>

                )}







                <div className="sr-detail-group">



                  <label>LOCATION</label>





                  <p className="sr-location-address">88 Fair Drive<br/>Costa Mesa, CA 92626</p>



                </div>



              </div>



            </div>



          </div>







          <div className="sr-actions">



            {(() => {



              const currentTicket = tickets[activeTicket];



              const isVendorBooth = currentTicket?.metadata?.business_type;



              const isVendorFestivalTicket = currentTicket?.ticket_type_name?.toLowerCase().includes('vendor') && !isVendorBooth;



              



              return (



                <>



              



                  



                  {/* Vendor Booth: Sign Contract, Download PDF */}



                  {isVendorBooth && (



                    <>



                      <button 



                        className="sr-outline-btn" 



                        onClick={() => {

                          if (!isAuthenticated) {

                            toast.info('Please create your account first to sign the contract.');

                            return;

                          }

                          handleSignContract();

                        }}



                        disabled={contractLoading || !isAuthenticated}



                        style={{



                          background: 'transparent',



                          color: isAuthenticated ? '#000' : '#666',



                          border: `2px solid ${isAuthenticated ? '#000' : '#999'}`,



                          fontWeight: '700',



                          fontSize: '15px'



                        }}



                      >



                        {contractLoading ? '⏳ Preparing Contract...' : !isAuthenticated ? '🔒 Create Account to Sign Contract' : '✍️ Sign Vendor Contract'}



                      </button>



                      <button 



                        className="sr-outline-btn" 



                        onClick={handleDownloadPDF}



                      >



                         Download PDF



                      </button>



                      <button 

                        className="sr-dashboard-btn" 

                        onClick={() => window.location.href = '/dashboard'}

                      >

                        Go to Dashboard

                      </button>



                    </>



                  )}



                  



                  {/* Vendor Festival Ticket: Download PDF, Apple Wallet, Google Wallet */}



                  {isVendorFestivalTicket && (



                    <>



                      <div style={{ width: '100%', maxWidth: '240px', margin: '0 auto 12px' }}>

                        <img loading="lazy" 

                          src={getCmsImagePath('appleBadge', '/apple.webp')} 

                          alt="Add to Apple Wallet"

                          style={{

                            width: '100%',

                            height: 'auto',

                            display: 'block',

                            cursor: 'pointer',

                            borderRadius: '8px',

                            border: '1.5px solid #1a1a1a'

                          }}

                          className="sr-wallet-img"

                          onClick={() => handleAppleWallet(currentTicket?.id)}

                        />

                      </div>



                      {googleWalletEnabled && (

                      <div style={{ width: '100%', maxWidth: '240px', margin: '0 auto 12px' }}>

                        <img loading="lazy" 

                          src={getCmsImagePath('googleWalletBadge', '/enUS_add_to_google_wallet_add-wallet-badge.svg')} 

                          alt="Add to Google Wallet"

                          style={{

                            width: '100%',

                            height: 'auto',

                            display: 'block',

                            cursor: 'pointer',

                            borderRadius: '8px',

                           

                          }}

                          className="sr-wallet-img"

                          onClick={() => handleGoogleWallet(currentTicket?.id)}

                        />

                      </div>

                      )}



                      <button 

                        className="sr-outline-btn" 

                        onClick={handleDownloadPDF}

                      >

                        Download PDF

                      </button>



                      <button 

                        className="sr-dashboard-btn" 

                        onClick={() => window.location.href = '/dashboard'}

                      >

                        Go to Dashboard

                      </button>



                    </>



                  )}



                  



                  {/* Regular Tickets: Download PDF + Wallet options */}



                  {!isVendorBooth && !isVendorFestivalTicket && (



                    <>



                      <div style={{ width: '100%', maxWidth: '240px', margin: '0 auto 12px' }}>

                        <img loading="lazy" 

                          src={getCmsImagePath('appleBadge', '/apple.webp')} 

                          alt="Add to Apple Wallet"

                          style={{

                            width: '100%',

                            height: 'auto',

                            display: 'block',

                            cursor: 'pointer',

                            borderRadius: '8px',

                          

                          }}

                          className="sr-wallet-img"

                          onClick={() => handleAppleWallet(currentTicket?.id)}

                        />

                      </div>



                      {googleWalletEnabled && (

                      <div style={{ width: '100%', maxWidth: '240px', margin: '0 auto 12px' }}>

                        <img loading="lazy" 

                          src={getCmsImagePath('googleWalletBadge', '/enUS_add_to_google_wallet_add-wallet-badge.svg')} 

                          alt="Add to Google Wallet"

                          style={{

                            width: '100%',

                            height: 'auto',

                            display: 'block',

                            cursor: 'pointer',

                            borderRadius: '8px',

                      

                          }}

                          className="sr-wallet-img"

                          onClick={() => handleGoogleWallet(currentTicket?.id)}

                        />

                      </div>

                      )}



                      <button 

                        className="sr-outline-btn" 

                        onClick={handleDownloadPDF}

                      >

                        Download PDF

                      </button>



                      <button 

                        className="sr-dashboard-btn" 

                        onClick={() => window.location.href = '/dashboard'}

                      >

                        Go to Dashboard

                      </button>



                    </>



                  )}



                </>



              );



            })()}



          </div>







          {/* Existing account user (not logged in) — show inline note, no blocking modal */}

          {!isAuthenticated && emailAlreadyRegistered && (

            <div style={{ 

              marginTop: '24px', 

              textAlign: 'center',

              padding: '24px',

              backgroundColor: '#f0fdf4',

              borderRadius: '12px',

              border: '2px solid #22c55e'

            }}>

              <h3 style={{ marginBottom: '8px', color: '#16a34a', fontSize: '18px', fontWeight: '600' }}>

                Tickets Linked to Your Account

              </h3>

              <p style={{ marginBottom: '16px', color: '#666', fontSize: '14px' }}>

                Your tickets have been added to your existing account.<br/>

                Log in to your dashboard to view and manage them.

              </p>

              <button 

                onClick={() => window.location.href = '/login'}

                style={{ 

                  margin: 'unset',

                  borderRadius: '56px',

                  border: '1px solid #D42533',

                  backgroundColor: '#D42533',

                  color: '#fff',

                  fontSize: '18px',

                  lineHeight: '1',

                  fontWeight: '600',

                  paddingBlock: '18px',

                  width: '100%',

                  cursor: 'pointer',

                  display: 'block'

                }}

              >

                Go to Login

              </button>

            </div>

          )}









          {/* Post-purchase upsell banner (20-min one-time offer, brand-new
              customers only). Self-hides when the server rejects the offer or
              the timer runs out.
              `buyerEmail` is passed so Cart.jsx can verify the coupon/window
              written to localStorage belongs to THIS buyer — not some previous
              user on the same browser (fixes cross-user UPSELL-AMP-20 leak). */}
          <UpsellBanner
            sessionId={searchParams.get('session_id')}
            buyerEmail={orderData?.buyer?._real_email || orderData?.buyer?.email}
          />

          <div className="sr-divider" />



          <div className="sr-bottom-grid">



            <div className="sr-info-left">



              <div className="sr-billing-shipping">



                <div className="sr-block">



                  <h3>Billing Address</h3>



                  <p className="sr-line">{orderData.buyer?.full_name || 'N/A'}</p>



                  {orderData.billing_address && (



                    <>



                      <p className="sr-line">{orderData.billing_address.line1}</p>



                      {orderData.billing_address.line2 && <p className="sr-line">{orderData.billing_address.line2}</p>}



                      <p className="sr-line">{orderData.billing_address.city}, {orderData.billing_address.state} {orderData.billing_address.postal_code}</p>



                      <p className="sr-line">{orderData.billing_address.country}</p>



                    </>



                  )}



                </div>







                <div className="sr-block sr-order-meta">



                  <div className="sr-meta-row">



                    <div>



                      <div className="label">ORDER NUMBER</div>



                      <div className="value">{orderData.order_number}</div>



                    </div>



                  </div>



                  <div className="sr-meta-row">



                    <div>



                      <div className="label">DATE</div>



                      <div className="value">{new Date(orderData.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</div>



                    </div>



                  </div>



                  <div className="sr-meta-row">



                    <div>



                      <div className="label">EMAIL</div>



                      <div className="value">{orderData.buyer?.email || 'N/A'}</div>



                    </div>



                  </div>



                  <div className="sr-meta-row">



                    <div>



                      <div className="label">PAYMENT METHOD</div>



                      <div className="value">{orderData.card_brand ? `${orderData.card_brand} ****${orderData.card_last4}` : 'Card'}</div>



                    </div>



                  </div>



                </div>









              </div>



            </div>







            <div className="sr-summary-card">



              <h3>Order Summary</h3>



              <div className="sr-summary-header">



                <span>Product</span>



                <span>Total</span>



              </div>



              {(() => {

                // Group items by base name (strip day suffix like " - Friday, June 19") and filter $0.00

                const grouped = {};

                (orderData.items || []).forEach(item => {

                  const totalPrice = (item.unit_price_cents / 100) * item.quantity;

                  if (totalPrice <= 0) return; // Skip $0.00 items

                  // Strip day suffix from pass names (e.g. "3-Day Pass - Friday, June 19" → "3-Day Pass")

                  const baseName = item.name.replace(/\s*-\s*(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday),?\s.*/i, '');

                  if (grouped[baseName]) {

                    grouped[baseName].quantity += item.quantity;

                    grouped[baseName].totalCents += item.unit_price_cents * item.quantity;

                  } else {

                    grouped[baseName] = { name: baseName, quantity: item.quantity, totalCents: item.unit_price_cents * item.quantity };

                  }

                });

                return Object.values(grouped).map((g, idx) => (

                  <div key={idx} className="sr-summary-row">

                    <span>{g.quantity}x {g.name}</span>

                    <span>${(g.totalCents / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>

                  </div>

                ));

              })()}



              <div className="sr-summary-row subtotal">



                <span>Subtotal</span>



                <span>${((orderData.metadata?.original_subtotal_cents || orderData.subtotal_cents) / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>



              </div>



              {orderData.metadata?.coupon_code && orderData.metadata?.discount_cents > 0 && (



                <div className="sr-summary-row" style={{ color: '#16a34a' }}>



                  <span>Discount ({orderData.metadata.coupon_code} - {orderData.metadata.discount_percent}% off)</span>



                  <span>-${(orderData.metadata.discount_cents / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>



                </div>



              )}



              {orderData.fees_cents > 0 && (



                <div className="sr-summary-row">



                  <span>Processing Fee</span>



                  <span>${(orderData.fees_cents / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>



                </div>



              )}



              {orderData.tax_cents > 0 && (



                <div className="sr-summary-row">



                  <span>Sales Tax (7.75%)</span>



                  <span>${(orderData.tax_cents / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>



                </div>



              )}



              <div className="sr-summary-row total">



                <span>Total</span>



                <span className="sr-total-amount">USD ${(orderData.total_cents / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>



              </div>



            </div>



          </div>



        </TornPaperWrapper>







        {/* Lanterns */}



        <div className="lanterns-container">



          <img loading="lazy" src={getCmsImagePath('lanterns', '/lanterns.webp')} alt="Festival Lanterns" className="lanterns-image" />



        </div>



      </section>



      {/* DocuSign Contract Modal */}



      {showContractModal && contractUrl && (



        <div style={{



          position: 'fixed',



          top: 0,



          left: 0,



          right: 0,



          bottom: 0,



          backgroundColor: 'rgba(0,0,0,0.7)',



          zIndex: 10000,



          display: 'flex',



          alignItems: 'center',



          justifyContent: 'center',



          padding: '20px'



        }}>



          <div style={{



            backgroundColor: 'white',



            borderRadius: '16px',



            width: '100%',



            maxWidth: '900px',



            height: '90vh',



            display: 'flex',



            flexDirection: 'column',



            overflow: 'hidden',



            boxShadow: '0 25px 50px rgba(0,0,0,0.3)'



          }}>



            <div style={{



              padding: '16px 24px',



              borderBottom: '1px solid #e5e7eb',



              display: 'flex',



              justifyContent: 'space-between',



              alignItems: 'center',



              background: 'linear-gradient(135deg, #7c3aed 0%, #9333ea 100%)',



              color: 'white',



              borderRadius: '16px 16px 0 0'



            }}>



              <div>



                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700' }}>



                  ✍️ Vendor Contract - Please Sign



                </h3>



                <p style={{ margin: '4px 0 0', fontSize: '12px', opacity: 0.9 }}>



                  You must sign this contract to complete your vendor registration.



                </p>



              </div>



            </div>



            <iframe



              src={contractUrl}



              style={{



                flex: 1,



                border: 'none',



                width: '100%'



              }}



              title="DocuSign Contract"



            />



          </div>



        </div>



      )}



      {/* Password Modal — rendered OUTSIDE TornPaperWrapper to avoid stacking context */}

      {showPasswordModal && (

        <div style={{

          position: 'fixed',

          top: 0,

          left: 0,

          right: 0,

          bottom: 0,

          backgroundColor: 'rgba(0,0,0,0.5)',

          display: 'flex',

          alignItems: 'center',

          justifyContent: 'center',

          zIndex: 10001,

          padding: '20px'

        }}>

          <div style={{

            backgroundColor: 'white',

            borderRadius: '12px',

            padding: '32px',

            maxWidth: '450px',

            width: '100%',

            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'

          }}>

            <h2 style={{ marginBottom: '8px', fontSize: '32px', fontWeight: '700', color: '#1a1a1a', fontFamily: "'Georgia', serif", textAlign: 'center' }}>

              {emailAlreadyRegistered || passwordError?.includes('already exists') || passwordError?.includes('Account already')

                ? 'Welcome Back!'

                : 'Create Your Account'}

            </h2>

            <p style={{ marginBottom: '24px', color: '#666666', fontSize: '17px', textAlign: 'center' }}>

              {emailAlreadyRegistered || passwordError?.includes('already exists') || passwordError?.includes('Account already') 

                ? 'This email already has an account. Please login to access your tickets and dashboard.' 

                : 'Create a password to access your tickets anytime and manage your orders'}

            </p>

            

            {emailAlreadyRegistered && !passwordError ? (

              <div style={{ display: 'flex', gap: '12px', flexDirection: 'column' }}>

                <button

                  type="button"

                  onClick={() => window.location.href = '/login'}

                  style={{

                    margin: 'unset',

                    borderRadius: '56px',

                    border: '1px solid #D42533',

                    backgroundColor: '#D42533',

                    color: '#fff',

                    fontSize: '18px',

                    lineHeight: '1',

                    fontWeight: '600',

                    paddingBlock: '18px',

                    width: '100%',

                    transition: 'none !important',

                    cursor: 'pointer',

                    display: 'block !important'

                  }}

                >

                  Go to Login

                </button>

                <button

                  type="button"

                  onClick={() => setShowPasswordModal(false)}

                  style={{

                    margin: 'unset',

                    borderRadius: '56px',

                    border: '1px solid #e5e7eb',

                    backgroundColor: 'transparent',

                    color: '#666',

                    fontSize: '16px',

                    lineHeight: '1',

                    fontWeight: '500',

                    paddingBlock: '14px',

                    width: '100%',

                    cursor: 'pointer'

                  }}

                >

                  Stay on this page

                </button>

              </div>

            ) : (

            <form onSubmit={handleSetPassword}>

              <div style={{ marginBottom: '26px', position: 'relative' }}>

                <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '17px', color: '#333333' }}>

                  Create password <span style={{ color: '#dc2626' }}>*</span>

                </label>

                <input

                  type={showPassword ? 'text' : 'password'}

                  value={password}

                  onChange={(e) => setPassword(e.target.value)}

                  placeholder="At least 8 characters"

                  required

                  minLength={8}

                  style={{

                    width: '100%',

                    padding: '12px',

                    paddingRight: '40px',

                    border: '1px solid #e5e7eb',

                    borderRadius: '8px',

                    fontSize: '14px',

                    boxSizing: 'border-box'

                  }}

                />

                <button

                  type="button"

                  onClick={() => setShowPassword(!showPassword)}

                  style={{

                    position: 'absolute',

                    right: '12px',

                    bottom: '0',

                    height: '44px',

                    display: 'flex',

                    alignItems: 'center',

                    justifyContent: 'center',

                    background: 'none',

                    border: 'none',

                    cursor: 'pointer',

                    color: '#6b7280',

                    padding: '0'

                  }}

                >

                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}

                </button>

              </div>



              <div style={{ marginBottom: '16px', position: 'relative' }}>

                <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500', fontSize: '17px', color: '#333333' }}>

                  Re-type password <span style={{ color: '#dc2626' }}>*</span>

                </label>

                <input

                  type={showConfirmPassword ? 'text' : 'password'}

                  value={confirmPassword}

                  onChange={(e) => setConfirmPassword(e.target.value)}

                  placeholder="Re-enter password"

                  required

                  minLength={8}

                  style={{

                    width: '100%',

                    padding: '12px',

                    paddingRight: '40px',

                    border: '1px solid #e5e7eb',

                    borderRadius: '8px',

                    fontSize: '14px',

                    boxSizing: 'border-box'

                  }}

                />

                <button

                  type="button"

                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}

                  style={{

                    position: 'absolute',

                    right: '12px',

                    bottom: '0',

                    height: '44px',

                    display: 'flex',

                    alignItems: 'center',

                    justifyContent: 'center',

                    background: 'none',

                    border: 'none',

                    cursor: 'pointer',

                    color: '#6b7280',

                    padding: '0'

                  }}

                >

                  {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}

                </button>

              </div>



              <div className="form-consent">

                <p className="consent-text"><strong>OPTIONAL:</strong><br/>I wish to receive transactional SMS messages from OC MENA Festival regarding orders (not required for purchase). By providing your mobile number and checking this box, you agree to receive transactional SMS messages from OC MENA Festival related to your order. Message frequency varies. Message and data rates may apply. Reply STOP to opt out, HELP for help. View our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: '#dc2626', textDecoration: 'underline' }}>Privacy Policy</a> and <a href="/terms-of-use" target="_blank" rel="noopener noreferrer" style={{ color: '#dc2626', textDecoration: 'underline' }}>Terms</a>.</p>

                <label className="checkbox-label" style={{ paddingLeft: '28px' }} onClick={(e) => e.stopPropagation()}>

                  <input

                    type="checkbox"

                    className="checkbox-input"

                    checked={smsConsent}

                    onChange={(e) => setSmsConsent(e.target.checked)}

                  />

                  <span className="checkbox-custom"></span>

                  <span>I agree to receive transactional SMS messages from OC MENA Festival regarding orders.</span>

                </label>

              </div>



              <p style={{ margin: '0 0 16px', fontSize: '12px', color: '#888', lineHeight: '1.5' }}>

                By creating an account you agree to our{' '}

                <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: '#dc2626', textDecoration: 'underline' }}>Privacy Policy</a>{' '}and{' '}

                <a href="/terms-of-use" target="_blank" rel="noopener noreferrer" style={{ color: '#dc2626', textDecoration: 'underline' }}>Terms of Use</a>.

              </p>



              {passwordError && (

                <div style={{ 

                  padding: '12px', 

                  backgroundColor: '#fee2e2', 

                  color: '#dc2626', 

                  borderRadius: '8px', 

                  marginBottom: '16px',

                  fontSize: '14px'

                }}>

                  {passwordError}

                </div>

              )}



              <div style={{ display: 'flex', gap: '12px', flexDirection: 'column' }}>

                {passwordError?.includes('already exists') || passwordError?.includes('Account already') ? (

                  <button

                    type="button"

                    onClick={() => window.location.href = '/login'}

                    style={{

                      margin: 'unset',

                      borderRadius: '56px',

                      border: '1px solid #D42533',

                      backgroundColor: '#D42533',

                      color: '#fff',

                      fontSize: '18px',

                      lineHeight: '1',

                      fontWeight: '600',

                      paddingBlock: '18px',

                      width: '100%',

                      transition: 'none !important',

                      cursor: 'pointer',

                      display: 'block !important'

                    }}

                  >

                    Go to Login

                  </button>

                ) : (

                  <button

                    type="submit"

                    disabled={settingPassword}

                    style={{

                      margin: 'unset',

                      borderRadius: '56px',

                      border: '1px solid #D42533',

                      backgroundColor: '#D42533',

                      color: '#fff',

                      fontSize: '18px',

                      lineHeight: '1',

                      fontWeight: '600',

                      paddingBlock: '18px',

                      width: '100%',

                      transition: 'none !important',

                      cursor: 'pointer',

                      display: 'block !important'

                    }}

                  >

                    {settingPassword ? 'Creating...' : 'Create Account'}

                  </button>

                )}

              </div>

            </form>

            )}

          </div>

        </div>

      )}



      <Footer />



    </div>



  );



};







export default OrderSuccess;



